var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgEl5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 57,
    viewBox: "0 0 40 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1508 24.5935C33.8359 23.1399 30.5209 21.6864 27.1024 20.129C25.3413 17.741 24.3054 15.0416 23.9946 12.1345C23.2694 8.81209 23.0623 5.59351 22.9587 2.16729C22.7515 -1.15511 17.8827 -0.428329 17.8827 2.79024C17.9862 14.0033 11.7707 23.1399 1.51509 27.6044C-1.1783 28.7465 0.0648034 32.6918 2.55102 32.4842C2.86179 32.6918 3.06897 32.7956 3.48334 32.8995C11.8743 34.6645 16.9503 41.2055 17.2611 48.9923C17.0539 50.6535 16.8467 52.3147 16.8467 54.0797C16.8467 54.2874 16.8467 54.495 16.8467 54.8065C16.8467 57.8174 21.4048 57.6098 21.9227 54.9103C22.3371 52.8338 22.4407 50.8612 22.4407 48.8885C23.9946 40.0634 29.6921 33.1071 38.3939 29.4732C41.1909 28.3312 40.0514 24.3858 37.1508 24.5935ZM20.2653 39.6481C17.9862 35.0798 14.1533 31.4459 8.97371 29.2656C13.9461 25.9432 17.7791 21.4787 20.1617 16.1837C21.9228 21.5825 24.9269 26.2547 29.8994 28.435C25.6521 31.3421 22.4407 35.1836 20.2653 39.6481Z",
    fill: "#F5F5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgEl5);
export default __webpack_public_path__ + "static/media/bg-el-5.694d0d9ece8871e5f9bcfdc90b5b6184.svg";
export { ForwardRef as ReactComponent };